import { Navigate, useLocation } from "react-router-dom";
import { useCustomerAuth } from "../contexts/CustomerAuthContext";

export function CustomerProtectedRoute({ children }) {
    const { user, loading } = useCustomerAuth();
    const location = useLocation();
    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-ivory" data-testid="customer-loading">
                <div className="font-serif text-xl text-inkDark">Loading...</div>
            </div>
        );
    }
    if (!user) {
        const next = encodeURIComponent(location.pathname + location.search);
        return <Navigate to={`/login?next=${next}`} replace />;
    }
    return children;
}
